import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
// import Fade from '@mui/material/Fade';
import Slide from '@mui/material/Slide';
// import Grow from '@mui/material/Grow';
import Alert from '@mui/material/Alert';

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

// function GrowTransition(props) {
//   return <Grow {...props} />;
// }

export default function SnackBar(props) {
  // const [state, setState] = React.useState({
  //   open: false,
  //   Transition: Fade,
  // });

  // const handleClick = (Transition) => () => {
  //   setState({
  //     open: true,
  //     Transition,
  //   });
  // };

  // const handleClose = () => {
  //   setState({
  //     ...state,
  //     open: false,
  //   });
  // };

  return (
    <div>
      {/* <Button onClick={handleClick(GrowTransition)}>Grow Transition</Button>
      <Button onClick={handleClick(Fade)}>Fade Transition</Button>
      <Button onClick={handleClick(SlideTransition)}>Slide Transition</Button> */}
      <Snackbar
        open={props.snackBarState}
        onClose={props.handleSnackBarClosed}
        TransitionComponent={SlideTransition}
        // message="I love snacks"
        key={SlideTransition.name}
        autoHideDuration={6000}
      >
    <Alert
          onClose={props.handleSnackBarClosed}
          severity="success" //or error
          variant="filled"
          sx={{ width: '100%' }}
        >
          {props.alertMessage}
        </Alert>


      </Snackbar>
    </div>
  );
}


